import React, { Fragment, useState } from 'react';


const EditClient = ({ this_client, refresh_clients }) => {

    const [name, setName] = useState(this_client.name)
    const [client_description, setClient_description] = useState(this_client.client_description)
    const [client_active, setClient_active] = useState(this_client.client_active)


    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);


    const reset = async (e) => {
        setName(this_client.name)
        setClient_description(this_client.client_description)
        setSuccess(false);
        setFailure(false);

    }



    function switchActive() {
        setClient_active(!client_active)
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();
        const client_id = this_client.client_id
        const body = { name, client_description, client_active, client_id }
        await fetch("/clients/update", {
            method: "PUT",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        }).then(function (response) {
            if (response.status === 404 || response.status === 403 || response.status === 409) {
                setFailure(true)
                setSuccess(false)
            } else {
                setSuccess(true)
                setFailure(false)
            }
        }).catch(function (response) {
            setFailure(true)
            setSuccess(false)
        })

        refresh_clients()
    }


    return (
        <Fragment>
            <button type="button" className="btn btn-info" data-toggle="modal" data-target={`#id_admin_client_edit${this_client.client_id}`}>
                Edit
            </button>

            <div className="modal fade" id={`id_admin_client_edit${this_client.client_id}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Client Information</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => reset()}>&times;</button>
                        </div>

                        <div className="modal-body">

                            <form onSubmit={onSubmitForm}>
                                <p>Client ID: {this_client.client_id}</p>
                                <p>NDIS number: {this_client.ndis_number}</p>


                                <input type="text" className="form-control m-1" value={name} onChange={e => setName(e.target.value)} />
                                <textarea type="text" className="form-control m-1" value={client_description} onChange={e => setClient_description(e.target.value)} />

                                <input placeholder="Active" type="checkbox" className="form-check-input ml-2 mt-2" id="make_active" checked={client_active} value={client_active} onChange={switchActive} />
                                <label className="form-check-label ml-5 mt-1" htmlFor="make_active">
                                    Active
                                </label>
                                <br />
                                <button type="submit" className="btn btn-success m-1" >Update</button>
                                {success && <p className="text-success">It Worked</p>}
                                {failure && <p className="text-danger">Didn't work, try again!</p>}
                            </form>


                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning" data-dismiss="modal" onClick={() => reset()}>Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default EditClient;